import en from './en.json'
const trans = en
export default trans
